var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dashboard-shipments-state',{staticClass:"dashboard-shipments-state-planned",attrs:{"count":_vm.loaded ? _vm.$n(_vm.count) : '-',"title":_vm.$tc("dashboard.titles.shipments.planned", !_vm.loaded ? 0 : _vm.count),"state":"planned"}})}
var staticRenderFns = []

export { render, staticRenderFns }